import React from 'react';
import login from "../consumers/login";
import GoogleButton from 'react-google-button'

const GoogleLogin = ({auth, googleProvider})=> {

    function login() {
        if (auth && googleProvider) {
            auth.signInWithPopup(googleProvider).then(function(result) {
                console.log("USER", result.user);
            }).catch((error)=>console.log("ERROR", error));
        }
    }

    return(
        <GoogleButton
            className="mx-auto mt-12"
            type="light"
            onClick={()=>login()}
        />
    );
};

const Login = login(GoogleLogin);
export default Login;


// WEBPACK FOOTER //
// ./src/subscribers/Login.js